module.exports = __webpack_public_path__ + "img/ie-square.14123320.svg";